import React, { useState } from 'react';  
    import { Link, useNavigate } from 'react-router-dom';  
    import axios from 'axios';  
    import { useToken } from '../contex/TokenProvider';
    import '../Style/AddProperty.css';
    import { AiOutlineLoading3Quarters } from "react-icons/ai"; 
    import BaseUrl from '../api/BaseUrl';

    function AddProperties() {  
        const navigate = useNavigate();  
        const {token} = useToken();

        const [formData, setFormData] = useState({  
            category: '',  
            title: '',  
            description: '',  
            image: null,  
            state: '',  
            address: '',  
            bedrooms: '',  
            bathrooms: '',  
            surface: '',  
            year: '',  
            price: '',  
        });  

        const [loading, setLoading] = useState(false);
        const [errorMessage, setErrorMessage] = useState('');

        const handleImageChange = (e) => {  
            const file = e.target.files[0];  
            if (file) {  
                setFormData({ ...formData, image: file });  
            } 
        };  

        const handleSubmit = async (e) => {  
            e.preventDefault();  
            setLoading(true);
            const formDataToSend = new FormData();  
            for (const key in formData) {  
                formDataToSend.append(key, formData[key]);  
            }  

            if (formData.image) {  
                formDataToSend.append('Image', formData.image);  
            } 

            try{
            const response = await BaseUrl.post('/Property/add-property', formDataToSend, {  
                headers: {  
                    'Authorization': `Bearer ${token}`,  
                    }
                }); 
                navigate('/properties');
               
            } catch(error) {
                let mess = "";
                if(error.response){
                    if(error.response.status === 401){
                        mess = "System error. Please refresh and try again";
                    }else if(error.response.status === 500){
                        mess = "Internal server error";
                    }else{
                        mess = error.response.data.message || mess;
                    }
                }
                setErrorMessage(mess);
            }finally {
                 setLoading(false);
            }
                  
        };  

        const isUploadDisabled = !formData;

        return (  
            <div className='flex justify-center items-center mx-[100px] py-[150px]'>  
                <div className='px-5 py-5 border-2 rounded-lg flex flex-col mx-auto gap-5 bg-slate-100'>  
                    <div className='text-center text-[20px] text-gray-600 bg-slate-200 rounded-md shadow-md font-bold py-2'>  
                        <h1>Add Property</h1>  
                    </div>  
                    {errorMessage && <p className='text-red-500 text-center'>{errorMessage}</p>}
                    <form onSubmit={handleSubmit} className='flex flex-row flex-wrap gap-10 py-5'>  
                        <div className='flex flex-col'>  
                            <label>Category *</label>  
                            <input required onChange={e => setFormData({ ...formData, category: e.target.value })} type='text' name='category' placeholder='category of property' />  
                        </div>  

                        <div className='flex flex-col'>  
                            <label>Title *</label>  
                            <input required onChange={e => setFormData({ ...formData, title: e.target.value })} type='text' name='title' placeholder='title of property' />  
                        </div>  

                        <div className='flex flex-col'>  
                            <label>Description *</label>  
                            <input required onChange={e => setFormData({ ...formData, description: e.target.value })} type='text' name='description' placeholder='description' />  
                        </div>  

                        <div className='flex flex-col'>  
                            <label>State *</label>  
                            <input required onChange={e => setFormData({ ...formData, state: e.target.value })} type='text' name='state' placeholder='state' />  
                        </div>  

                        <div className='flex flex-col'>  
                            <label>Address *</label>  
                            <input required onChange={e => setFormData({ ...formData, address: e.target.value })} type='text' name='address' placeholder='address' />  
                        </div>  

                        <div className='flex flex-col'>  
                            <label>Bedrooms</label>  
                            <input onChange={e => setFormData({ ...formData, bedrooms: e.target.value })} type='text' name='bedrooms' placeholder='bedrooms' />  
                        </div>  

                        <div className='flex flex-col'>  
                            <label>Bathrooms</label>  
                            <input onChange={e => setFormData({ ...formData, bathrooms: e.target.value })} type='text' name='bathrooms' placeholder='bathrooms' />  
                        </div>  

                        <div className='flex flex-col'>  
                            <label>Surface</label>  
                            <input onChange={e => setFormData({ ...formData, surface: e.target.value })} type='text' name='surface' placeholder='surface' />  
                        </div>  

                        <div className='flex flex-col'>  
                            <label>Year</label>  
                            <input onChange={e => setFormData({ ...formData, year: e.target.value })} type='text' name='year' placeholder='year' />  
                        </div>  

                        <div className='flex flex-col'>  
                            <label>Price</label>  
                            <input onChange={e => setFormData({ ...formData, price: e.target.value })} type='text' name='price' placeholder='price' />  
                        </div>  

                        <div className='flex flex-col'>  
                            <label>Image *</label>  
                            <input required onChange={handleImageChange} type='file' name='image' />  
                        </div>  

                        <div className='flex flex-row gap-2 justify-center items-center bg-slate-200 px-10 py-5 rounded-lg'>  
                            <button disabled={isUploadDisabled} className={`px-2 py-1 rounded-md bg-green-500 text-white ${isUploadDisabled ? 'bg-slate-300' : 'bg-green-500'}`}>
                                {loading ? <AiOutlineLoading3Quarters className='loading'/> : 'Submit'}
                            </button>  
                            <Link className='px-2 py-1 rounded-md bg-red-500 text-white' to={'/properties'}>Cancel</Link>  
                        </div>  
                    </form>  
                </div>  
            </div>  
        );  
    }  

    export default AddProperties;  
